import { Col, Form, Row, DatePicker, Card, Select, TimePicker,Space } from 'antd';
import Input from '../../../../../ui/Input';
import React, { useImperativeHandle, useRef, useState, forwardRef, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import PageContainer from '../../../../../CSIComponents/PageContainer';
import ApplicalbeDays from '../../../../../CSIComponents/ApplicalbeDays';
import { PlusOutlined } from '@ant-design/icons'
import { getOTACodes } from '../../../../../../services/common';
import {Moment} from 'moment'
import moment from 'moment';
const dateFormat = 'MM/DD/YYYY';
const formatTime = 'HH:mm';
const { Option } = Select;
const { RangePicker } = DatePicker;
let chargeErrHandle = false;
let descErrHandle = false;
const PolicyTypeOptions = ['Required Payment', 'Guarantee Policy', 'Accepted Payment Forms'];
const GuaranteeTypeOptions = ['Guarantee Required', 'None', 'CC/DC/Voucher', 'Profile', 'Deposit', 'PrePay'];
const TimeUnitOption = ['Year', 'Month', 'Week', 'Day', 'Hour', 'Minute', 'Second', 'Full Duration', 'Immediate']
const CalculateMethodOptions = ['Before Arrival', 'After Arrival', 'After Booking', 'After Confirmation', 'After Departure']

const DetailAdd = forwardRef((props: any, detailAddRef: any) => {
  const [form] = Form.useForm();
  const valueList = props.cancellationDetails.valueList;
  const applicalbeDaysRef = useRef({ resetData: () => { }, valueList })
  const [chargeName, setChargeName] = useState<any>(`Charge ()`);
  const [valueListAfterChanged, setValueListAfterChanged] = useState(valueList)
  useImperativeHandle(detailAddRef, () => ({ dayValueList: valueListAfterChanged, detailsForm: form, restoreErr: () => { chargeErrHandle = false; descErrHandle = false; } }))

  const [descript, setDescript] = useState([{ descript: '' }])

  const addDescript = () => {
    descript.push({ descript: '' })
    setDescript([...descript]);
  }
  const deleteDescript = () => {
    const descriptLastName = "descript-" + descript.length
    descript.pop()
    form.setFieldsValue({ [descriptLastName]: '' })
    setDescript([...descript]);
  }

  const [curData, setCurData] = useState([])
  const getCurData = async () => {
    let res = await getOTACodes('CUR', '')
    if (res && res.otacodes && res.otacodes.length != 0) {
      setCurData(res.otacodes)
    } else {
      setCurData([])
    }
  };
  useEffect(() => {
    getCurData();
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [])

  useEffect(() => {
    if (descErrHandle) {
      props.validateFieldsError();
    } else {
      descErrHandle = true;
    }
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [descript])

  useEffect(() => {
    if (chargeErrHandle) {
      props.validateFieldsError();
    } else {
      chargeErrHandle = true;
    }
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [chargeName])


  const [startDateValidation, setStartDateValidation] = useState<"" | "error" | "success" | "warning" | "validating" | undefined>('')
  const [endDateValidation, setEndDateValidation] = useState<"" | "error" | "success" | "warning" | "validating" | undefined>('')

  const onChangeStartDate = (e: Moment | null) => {
    const enddate: Moment = form.getFieldValue('enddate');
    if(!e){
      form.setFieldsValue({['startdate']:''})
      if(enddate){
        props.setValidateDate(true)
        setStartDateValidation('error');
      } 
      else{ 
        props.setValidateDate(false)
        setStartDateValidation('success');
        setEndDateValidation('success');
      }
      return;
    }

    form.setFieldsValue({['startdate']:e});
    if(!enddate || e.unix() < enddate.unix()) {
      props.setValidateDate(false)
      setStartDateValidation('success');
      setEndDateValidation('success');
    } else {
      props.setValidateDate(true)
      setStartDateValidation('error')
    }
   }
  
   const onChangeEndDate = (e: Moment | null) => {
    const startdate: Moment = form.getFieldValue('startdate');
   if(!e) {
     props.setValidateDate(false)
     setEndDateValidation('success');
     setStartDateValidation('success')
     form.setFieldsValue({['enddate']:''});
     return;
   }

   form.setFieldsValue({['enddate']:e})
   if(!startdate ) {
     props.setValidateDate(true)
     setEndDateValidation('error');
   }
   else if(startdate.unix() < e.unix()) {
     props.setValidateDate(false)
     setStartDateValidation('success')
     setEndDateValidation('success');
   } else {
     props.setValidateDate(true)
     setEndDateValidation('error')
   }
 }

  useEffect(()=>{
    props.validateFieldsError();
  },[props.validateDate]);


  return (<div style={{ marginBottom: '90px' }}>
    <Form
      layout="vertical"
      form={form}
      name="basic"
      style={{ padding: 0 }}
      onValuesChange={(changedFields, allFields) => {
        props.validateFieldsError();
      }}
    ><PageContainer>
        <Card style={{ marginTop: -15 }}>
          <Grid container spacing={0} className="containerSpacing py-0">
            <Grid item xs={12} className="p-0">
              <div>
                <div style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>Guarantee Payment</div>
              </div>
            </Grid>
            <Grid item xs={12} className="pb-0 px-0 my-0">

              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    label="Guarantee Payment Policy Name"
                    name="policyname"
                    rules={[{ max: 64, message: 'You have reached the max character length of 64' }]}
                  >
                    <Input maxLength={64} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="Policy Code"
                    name="policycode"
                    rules={[{ max: 16, message: 'You have reached the max character length of 16' }]}
                  >
                    <Input maxLength={16} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name='policytype' label="Policy Type" rules={[{ required: true, message: 'This field is required' }]}>
                    <Select allowClear showSearch>
                      {PolicyTypeOptions.map((item, index) => {
                        return <Option value={item} key={index}>{item}</Option>
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item name='guaranteetype' label="Guarantee Type">
                    <Select allowClear showSearch>
                      {GuaranteeTypeOptions.map((item, index) => {
                        return <Option value={item} key={index}>{item}</Option>
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item
                    label="Start Date"
                    name="startdate"
                    hasFeedback
                    validateStatus={startDateValidation} 
                    help={startDateValidation === 'error' ? 'Start date can not be a future day or empty if end date is not' : ''} 
                  >
                  <Space direction="vertical">
                    <DatePicker  format='MM/DD/YYYY' onChange={onChangeStartDate} />
                  </Space>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="End Date"
                    name="enddate"
                    hasFeedback
                    validateStatus={endDateValidation} 
                    help={endDateValidation === 'error' ? 'End date can not be a past date or start date is empty' : ''} 
                  >
                  <Space direction="vertical">
                    <DatePicker format='MM/DD/YYYY' onChange={onChangeEndDate} />
                  </Space>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={12} >
                  <ApplicalbeDays label="Applicable Days of the Week"
                    valueList={props.cancellationDetails.valueList}
                    ref={applicalbeDaysRef}
                    readOnly={false}
                    originData={props?.cancellationDetails?.valueList}
                    setValueListAfterChanged={setValueListAfterChanged} />
                </Col>
              </Row>
              <Row style={{ marginTop: 20 }}>
                <Col span={6}>
                  <Form.Item
                    label="Applies to Room Type Code"
                    name="roomtypecode"
                    rules={[{ max: 128, message: 'You have reached the max character length of 128' }]}
                  >
                    <Input maxLength={128} />
                  </Form.Item>
                </Col>
              </Row>
              {descript && descript.map((item, i) => {
                return <React.Fragment key={i}>
                  <Row gutter={24}>
                    <Col span={18}>
                      <Form.Item
                        label={"Description" + (i + 1)}
                        name={"descript-" + (i + 1)}
                        rules={[{ max: 300, message: 'You have reached the max character length of 300' }]}
                      >
                        <Input maxLength={300} />
                      </Form.Item>
                    </Col>
                  </Row>
                </React.Fragment>
              })}
              <Row gutter={24}>
                <Col span={18} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                  <div style={{ color: '#004771', display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={addDescript}><PlusOutlined style={{ marginRight: 4 }} />Add Description {descript.length + 1}</div>
                  {descript.length > 1 && <div style={{ color: '#f07171', marginLeft: 20, cursor: 'pointer' }} onClick={deleteDescript}>Delete</div>}
                </Col>
              </Row>
              <Row gutter={24} style={{ marginTop: 20 }}>
                <Col span={6}>
                  <Form.Item
                    label="Non-Refundable"
                    name="nonrefundable"

                  >
                    <Select allowClear showSearch>
                      <Option value="Yes">Yes</Option>
                      <Option value="No">No</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="Hold Time"
                    name="holdtime"
                  >
                    <TimePicker format={formatTime} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name='retribution' label="Retribution">
                    <Select allowClear showSearch>
                      <Option value="Res Auto Cancelled">Res Auto Cancelled</Option>
                      <Option value="Res Not Guaranteed">Res Not Guaranteed</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={6} className="col-margin">
                  <Form.Item name="chargetype" label="Charge Type" rules={[{ required: true, message: 'This field is required' }]}>
                    <Select allowClear showSearch onChange={value => {
                      setChargeName(`Charge (${value || ''})`);
                      form.setFieldsValue({ charge: '' });
                    }}>
                      <Option value="Amount">Amount</Option>
                      <Option value="Percent">Percent</Option>
                      <Option value="Nights">Nights</Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={6} className="col-margin" >
                  <Form.Item name="charge" label={chargeName}
                    rules={[
                      { required: true, message: 'This field is required' },
                      { pattern: (chargeName === 'Charge (Amount)' || chargeName === 'Charge (Percent)') ? /^\d*(\.\d*)?$/ : /^\d*$/, message: "This field should be a number." }
                    ]}>
                    <Input />
                  </Form.Item>
                </Col>
                <>
                  {
                    chargeName === 'Charge (Amount)' && <>

                      <Col span={6} className="col-margin">
                        <Form.Item name="currency" label="Currency" rules={[
                          { required: true, message: 'This field is required' },
                        ]}>
                          <Select allowClear showSearch
                            placeholder="Select a currency"
                            optionFilterProp="children"
                            // @ts-expect-error 
                            filterOption={(input, option) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {curData.map((item: any) => <Option value={item.codeName} key={item.codeValue}>{item.codeName}</Option>)}
                          </Select>
                        </Form.Item>
                      </Col>
                    </>
                  }
                </>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item name='timeunit' label="Time Unit">
                    <Select allowClear showSearch>
                      {TimeUnitOption.map((item, index) => {
                        return <Option value={item} key={index}>{item}</Option>
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="Number of Units"
                    name="noofunits"
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name='calculationmethod' label="Calculate Method">
                    <Select allowClear showSearch>
                      {CalculateMethodOptions.map((item, index) => {
                        return <Option value={item} key={index}>{item}</Option>
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Grid>
          </Grid>
        </Card>
      </PageContainer>
    </Form>

  </div >)
})

export default DetailAdd;
